import api from "../lib/apiClient";
export const listUsers = () => api.get("/admin/users").then((r) => r.data);
export const setVerification = (userId, status) => api.patch(`/admin/users/${userId}/verification`, { status }).then((r) => r.data);
